'use strict';

module.exports = {
  endpoint: 'https://api.magicthegathering.io/v1'
};